export default __webpack_public_path__ + "static/media/around-the-world.7166abb9.png";